import React, { useState, useEffect } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";

import { Icon } from "antd";
import { Layout } from "@arco-design/web-react";

import { useCommonModel } from "@/models";
import { ProjectLogo } from "./AppNav";
import AppSideNav from "./AppSideNav";

export const TOOL_PATH = [
  "/protection",
  "/gm-config",
  "/storeManagement/ios/reveal-scan",
  "/recommend",
  "/certManage",
  "/review/apple/iap",
  "/review/google/iap",
  "/hold-all/re-sign-package",
  "interfacetest",
  "/package-inspection/static-channel",
  "/privacy-scan",
  "/code-coverage",
];

export const TEST_MANAGE_PATH = [
  "/testManagement/transferOrder",
  "/testManagement/transferTask",
  "/testManagement/schedule",
  "/testManagement/wrapManage",
  "/testManagement/testReport",
  "/testManagement/testCase",
  "/storeManagement/ios",
  "/storeManagement/externalTF",
  "/storeManagement/google",
  "/operationManagement/quality-dashboard",
  "/operationManagement/issues/overview",
  "/operationManagement/issues/process",
  "/operationManagement/gameOperation",
  "/operationManagement/standard",
  "/operationManagement/quality-daily",
  "/operationManagement/quality-weekly",
  "/operationManagement/ro",
];

export const AUTH_PATH = [
  "/testManagement/schedule",
  "/storeManagement/ios",
  "/storeManagement/externalTF",
  "/storeManagement/google",
  "/operationManagement/issues/overview",
  "/operationManagement/standard",
  "/recommend",
];

export const OVERVIEW_PATH = [
  "/work-order",
  "/certs-management",
  "/online-market",
  "/qa-weekly",
  "/issues/overview",
  "/issues/process",
  "/issues/hierarchy",
  "/issues/stats",
  "/online-quality",
  "/onlinestatus/list/apple",
  "/onlinestatus/list/google",
  "/onlinestatus/list/google_beta",
  "/allqareviewing/list",
  "/bpo-overview",
  "/bpo-data-entry",
];

const SiderMenu: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const [{ projectID }] = useCommonModel();
  // console.log(projectID);
  const [collapsed, setCollapsed] = useState(false);
  const [isShowSider, setIsShowSider] = useState(true);
  const [navType, setNavType] = useState("testManage");
  useEffect(() => {
    // 需要隐藏侧边栏的页面
    const rootRoutes = [
      "/my-project",
      "/new-project",
      // '/qa-weekly',
      "/project-progress",
      "/external-scan",
      "/privacy-scan/report",
      "external-google-scan",
      "/external-flow-scan",
      "/external-googleFlow-scan",
      "/review/google/internal-scan",
      // '/work-order',
      "/personal-information",
      "/privilegeManagement/addPrivilegeManagement",
      "/role-permissions-apply",
      "/login",
      "/signout",
      "/download",
      "/share",
      // '/issues',
      "/summary",
      // '/online-quality',
      // '/online-market',
      "/execute-usecase",
      "/testManagement/transferTask/boundCase",
      "/releaseTest/transferTask/boundCase",
      "/appStoreUserManagement/list",
      "/googlePlayUserManagement/list",
      "/noPermission/download",
      // '/allqareviewing/list',
      // '/onlinestatus/list',
    ];

    if (
      location.pathname.includes("/project-detail") ||
      location.pathname.includes("/edit-project/edit") ||
      location.pathname.includes("/ro/preview") ||
      location.pathname.includes("/interfacetest/sh") ||
      rootRoutes.some(item => location.pathname.includes(item))
    ) {
      setIsShowSider(false);
    } else {
      setIsShowSider(true);
    }
    setNavType(switchNavType());
  }, [location]);

  const switchNavType = () => {
    if (TOOL_PATH.some(item => location.pathname.includes(item))) {
      return "toolbox";
    } else if (
      TEST_MANAGE_PATH.some(item =>
        (location.pathname + location.search).includes(item),
      )
    ) {
      return "testmanagement";
    } else if (OVERVIEW_PATH.some(item => location.pathname.includes(item))) {
      return "overview";
    } else if (localStorage.getItem("nav_type") === "overview") {
      return "overview";
    } else {
      return "testmanagement";
    }
  };

  return (
    <Layout.Sider
      collapsed={collapsed}
      breakpoint="xl"
      collapsedWidth={80}
      style={{
        display: isShowSider ? "block" : "none",
        // zIndex: 12,
      }}>
      {navType !== "overview" ? <ProjectLogo collapsed={collapsed} /> : null}
      {!collapsed ? (
        <Icon
          type="left-circle"
          className="footerFoldIcon"
          onClick={() => setCollapsed(true)}
        />
      ) : (
        <Icon
          type="right-circle"
          className="footerFoldIcon"
          onClick={() => setCollapsed(false)}
        />
      )}
      <AppSideNav
        collapsed={collapsed}
        projectID={projectID}
        navType={navType}
      />
    </Layout.Sider>
  );
};

export default SiderMenu;
